export default "__VITE_ASSET__SWBLBuPZ__"